'use strict';
/* The Atlas reads the existing lunar engine. It stores and transmits no personal data. */
(() => {
  const roots = document.querySelectorAll('[data-kg-atlas]');
  const sky = window.KG_CIELO;
  if (!sky || !roots.length) return;
  const decode = (text) => { const el = document.createElement('textarea'); el.innerHTML = text || ''; return el.value; };
  const formatter = (locale, options) => { try { return new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : locale, options); } catch { return new Intl.DateTimeFormat(undefined, options); } };
  roots.forEach((root) => {
    if (root.dataset.kgAtlasReady) return;
    root.dataset.kgAtlasReady = 'true';
    let texts;
    try { texts = JSON.parse(root.querySelector('[data-kg-atlas-texts]').textContent); } catch { return; }
    const fDate = formatter(texts.locale, { day: 'numeric', month: 'long' });
    const fMonth = formatter(texts.locale, { month: 'long', year: 'numeric' });
    let paintedMonth = '';
    function update(now = new Date()) {
      const phase = sky.luna(now);
      root.querySelector('[data-kg-atlas-date]').textContent = fDate.format(now);
      const practice = texts.practices?.[phase.chiave];
      if (practice && root.querySelector('[data-kg-atlas-gesture]')) {
        root.querySelector('[data-kg-atlas-practice]').textContent = decode(practice);
        root.querySelector('[data-kg-atlas-phase]').textContent = root.querySelector('[data-kg-campo="nome"]').textContent;
        const link = root.querySelector('[data-kg-atlas-practice-link]');
        const url = new URL(link.href);
        url.hash = `kg-pratica-${phase.chiave}`;
        link.href = url.href;
        root.querySelector('[data-kg-atlas-gesture]').hidden = false;
      }
      const monthKey = `${now.getFullYear()}-${now.getMonth()}`;
      if (monthKey === paintedMonth) {
        root.querySelectorAll('[data-kg-atlas-day]').forEach((day) => day.classList.toggle('kg-atlas__day--today', Number(day.dataset.kgAtlasDay) === now.getDate()));
        return;
      }
      const grid = root.querySelector('[data-kg-atlas-month-grid]');
      if (!grid) return;
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const days = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      const fragment = document.createDocumentFragment();
      for (let day = 1; day <= days; day++) {
        const lunarDay = sky.luna(new Date(now.getFullYear(), now.getMonth(), day, 12));
        const cell = document.createElement('span');
        cell.className = 'kg-atlas__day';
        cell.dataset.kgAtlasDay = day;
        cell.classList.toggle('kg-atlas__day--today', day === now.getDate());
        if (day === 1) cell.style.gridColumnStart = (start.getDay() + 6) % 7 + 1;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 100 100');
        svg.setAttribute('focusable', 'false');
        const circle = document.createElementNS(svg.namespaceURI, 'circle');
        circle.setAttribute('cx', '50'); circle.setAttribute('cy', '50'); circle.setAttribute('r', '46'); circle.setAttribute('fill', '#d7cdbb');
        svg.append(circle);
        if (window.KG_LUNA?.terminatore) {
          const lit = document.createElementNS(svg.namespaceURI, 'path');
          lit.setAttribute('d', window.KG_LUNA.terminatore(lunarDay.elong / 360, 46));
          lit.setAttribute('fill', '#4c454b'); svg.append(lit);
        }
        const label = document.createElement('span'); label.textContent = day;
        cell.append(svg, label); fragment.append(cell);
      }
      grid.replaceChildren(fragment);
      root.querySelector('[data-kg-atlas-month-title]').textContent = fMonth.format(now);
      root.querySelector('[data-kg-atlas-month]').hidden = false;
      paintedMonth = monthKey;
    }
    update();
    document.addEventListener('kg-luna:ora', (event) => update(event.detail?.ora || new Date()));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
    window.addEventListener('pageshow', (event) => { if (event.persisted) update(); });
  });
})();
